import React, { useMemo } from 'react'
import { Form } from 'semantic-ui-react'
import { useTextResources } from '../../language'
import PropTypes from 'prop-types'
import TransactionsDropDown from '../shared/TransactionsDropDown'
import CurrencyDropDown from '../shared/CurrencyDropDown'
import CurrencyInput from '../shared/CurrencyInput'
import { Currencies } from '../shared/currencies'
import BanksDropDown from '../shared/BanksDropDown'
import { DatePicker } from '../shared/DatePicker'
import { PaymentTypesEnum } from '../shared/constants'


const CreditPaymentDialog = ({ state, setState, readOnlyAmount }) => {
    const text = useTextResources()
    const currencySymbol = Currencies[state.selectedPaymentCurrency].symbol
    const TransactionsSpec = useMemo(() => {
        return { IsDebit: false }
    }, [])

    const filterTransactionCodes = (codes) => {
      //Was previously done at the server but due to the fact that city-ledger is HardCoded, had to be changed. 
      let filteredCodesNotHardCoded = codes.filter(
        (code) => !code.item.IsHardcoded
      );
      
      if (state.HardcodedTypeIDs) {
            filteredCodesNotHardCoded = filteredCodesNotHardCoded.filter(
            (x) =>
                !state.HardcodedTypeIDs.includes(
                x.item.TransactionCodeHardcodedTypeID
                )
            );
      }
      //If it's an agent or a company, we need to have city-ledger and so we push it back to the array
     
      if (state.isCityLadger) {       
        const cityLedger = codes.find(
          (c) => c.item.PaymentTypeId == PaymentTypesEnum.CityLedger
        );

        filteredCodesNotHardCoded =
          cityLedger
            ? [...filteredCodesNotHardCoded, cityLedger]
            : filteredCodesNotHardCoded;
      }

      if(state.blockFinancialDocuments)
      {
         filteredCodesNotHardCoded = filteredCodesNotHardCoded.filter(
          (x) => !x.item.BlockFinancialDocuments);
      }

      return filteredCodesNotHardCoded;
    };

    return <div>
        <Form>
            <Form.Group widths="2">
                <Form.Field disabled={readOnlyAmount} label={text("Amount")}
                    currency={currencySymbol}
                    control={CurrencyInput}
                    value={state.amount || 0}
                    onChange={val => setState({ ...state, amount: val })
                    } />
                <Form.Field
                    label={text("Currency")}
                    control={CurrencyDropDown}
                    value={state.selectedPaymentCurrency}
                    textField="Name"
                    descriptionField="Symbol"
                    onChange={val => setState({
                        ...state,
                        paymentCurrency: state.selectedPaymentCurrency,
                        selectedPaymentCurrency: val
                    })} />
            </Form.Group>
            <Form.Field required
                label={text("Transaction")}
                control={TransactionsDropDown}
                spec={TransactionsSpec}
                onChangeItem={val => setState({
                    ...state,
                    transactionCodeID: val.Id,
                    paymentTypeId: val.PaymentTypeId,
                    displayName: val.Name,
                    isExternalVoucherRequired: val.IsExternalVoucherRequired
                })}
                filter={filterTransactionCodes}></Form.Field>
            {state.paymentTypeId === 6 && <Form.Group>
                <Form.Field width={10}
                    label={text("Bank")}
                    value={state.ChecksDetails && state.ChecksDetails.BankID}
                    control={BanksDropDown}
                    onChange={value => setState({
                        ...state,
                        ChecksDetails: state.ChecksDetails ? {
                            ...state.ChecksDetails,
                            BankID: value
                        } : {
                            BankID: value
                        }
                    })} />
                <Form.Input width={6}
                    label={text("BranchCode")}
                    value={state.ChecksDetails && state.ChecksDetails.BranchCode}
                    onChange={(e, { value }) => setState({
                        ...state,
                        ChecksDetails: state.ChecksDetails ? {
                            ...state.ChecksDetails,
                            BranchCode: value
                        } : {
                            BranchCode: value
                        }
                    })}></Form.Input>
            </Form.Group>}
            {state.paymentTypeId === 6 && <Form.Group>
                <Form.Input width={5}
                    label={text("CheckNumber")}
                    value={state.ChecksDetails && state.ChecksDetails.CheckNumber}
                    onChange={(e, { value }) => setState({
                        ...state,
                        ChecksDetails: state.ChecksDetails ? {
                            ...state.ChecksDetails,
                            CheckNumber: value
                        } : {
                            CheckNumber: value
                        }
                    })}></Form.Input>
                <Form.Input width={5}
                    label={text("AccountNumber")}
                    value={state.ChecksDetails && state.ChecksDetails.AccountNumber}
                    onChange={(e, { value }) => setState({
                        ...state,
                        ChecksDetails: state.ChecksDetails ? {
                            ...state.ChecksDetails,
                            AccountNumber: value
                        } : {
                            AccountNumber: value
                        }
                    })}></Form.Input>
                <DatePicker width={6}
                    label={text("CheckDate")}
                    value={state.ChecksDetails && state.ChecksDetails.CheckDate}
                    onChange={value => setState({
                        ...state,
                        ChecksDetails: state.ChecksDetails ? {
                            ...state.ChecksDetails,
                            CheckDate: value
                        } : {
                            CheckDate: value
                        }
                    })} />
            </Form.Group>}
            <Form.Input label={text("DisplayName")} value={state.displayName} onChange={(e, { value }) => setState({
                ...state,
                displayName: value
            })}></Form.Input>
            <Form.Input label={text("Comments")} onChange={(e, { value }) => setState({
                ...state,
                comments: value
            })}></Form.Input>
            <Form.Input 
                label={text("Voucher")} 
                required={state.isExternalVoucherRequired === true}
                value={state.voucher || ''}
                onChange={(e, { value }) => setState({
                    ...state,
                    voucher: value
                })}></Form.Input>
        </Form>
    </div>
}

CreditPaymentDialog.propTypes = {
    state: PropTypes.any,
    setState: PropTypes.func,
    currencyRates: PropTypes.array,
    readOnlyAmount: PropTypes.bool
}

export default CreditPaymentDialog